import { render, staticRenderFns } from "./RuleDetails.vue?vue&type=template&id=c3ce502a&scoped=true&"
var script = {}
import style0 from "./RuleDetails.vue?vue&type=style&index=0&id=c3ce502a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ce502a",
  null
  
)

export default component.exports